import ScrollToTop from "../ScrollToTop";
import ReinicioPassw from "../RenicioPass";
import Banner from "../../components/Banner";
import { observer } from "mobx-react-lite";
import Footer from "../Footer";
import React, { useEffect, useState } from "react";

function PassReload() {
  const [banners, setBanners] = useState(false);

  const bannerMobile = () => {
    if (window.innerWidth < 1300) {
      setBanners(false);
    } else {
      setBanners(true);
    }
  };

  useEffect(() => {
    bannerMobile();
  }, []);

  window.addEventListener("resize", bannerMobile);
  return (
    <>
      {/* {banners ? (
        <>
          <Banner banner="images/teclado.jpg" />
        </>
      ) : (
        <>
          <Banner banner="images/liginMobile.jpg" />
        </>
      )} */}

      <ReinicioPassw />
    </>
  );
}

export default observer(PassReload);
